import {
  Box,
  Flex,
  FlexProps,
  Icon,
  SecondaryButton,
  Typo,
  useModal,
  xsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { canCancel, showCancel } from '../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { CancellationNotAllowedModal } from '../../../organisms/cancellation'
import { useProduct } from '../../ProductProvider'
import { PolicyPath } from '../PolicyPath'
import { usePolicy } from '../PolicyProvider'
import { PolicySidebarPricing } from '../pricing'

const tKey = TKey('components.policy-sidebar')

export const PolicySidebar: FunctionComponent<FlexProps> = (props) => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const { product } = useProduct()
  const { policy } = usePolicy()
  const { show } = useModal()

  const handleCancel = useCallback(() => {
    if (canCancel(policy, product.cancellation)) {
      navigate(PolicyPath.CANCEL)
    } else {
      show({
        content: <CancellationNotAllowedModal />,
      })
    }
  }, [product, policy])

  const benefits = t(tKey('benefits'), {
    returnObjects: true,
    defaultValue: [],
  }) as string[]

  const benefitsSection = benefits.map((benefit, index) => (
    <Flex justifyContent='flex-start' width={1} key={index}>
      <Icon icon='tick' size='small' mr={xsBumps} />
      <Typo typoSize='sm'>{benefit}</Typo>
    </Flex>
  ))

  return (
    <Flex width={1} flexDirection='column' variant='raised' {...props}>
      <PolicySidebarPricing policy={policy} product={product} width={1} />
      <Box
        borderTopWidth={1}
        collapseWhenEmpty={true}
        display='flex'
        flexDirection='column'
        rowGap={5}
        p={5}
        width={1}
      >
        {showCancel(policy, product) && (
          <SecondaryButton
            width={1}
            onClick={handleCancel}
            data-testid='button-cancel-policy'
          >
            {canCancel(policy, product.cancellation)
              ? t(tKey('actions.cancel'))
              : t(tKey('actions.contact'))}
          </SecondaryButton>
        )}
        {Boolean(benefitsSection.length) && (
          <Box display='flex' flexDirection='column' rowGap={xsBumps} width={1}>
            {benefitsSection}
          </Box>
        )}
      </Box>
    </Flex>
  )
}
